export {};
//# sourceMappingURL=types.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/react-components/~/react-inlinesvg/esm/types.js
// module id = 611
// module chunks = 4